import React from "react";
import * as PropTypes from "prop-types";
import InstrumentDetail from "../InstrumentDetail";
import { connect } from "react-redux";
import { getMeasurementType } from "../../Redux/reducers/measurements";
import { getAlertSpec } from "../InstrumentComponentHelper";
import {
  dateRenderer,
  sampleDateRenderer,
  sortBySampleDate,
  getMeasurementValue,
  sortByMeasurement,
} from "../InstrumentHelper";
import MeasurementStatus from "../Shared/TestsDatatable/MeasurementStatus";
import { notesColumn } from "../Shared/TestsDatatable/NotesColumn";
import {
  sampleStateRenderer,
  sortBySampleState,
} from "../../Samples/SampleHelper";
import TestDetailModal from "#components/Tests/TestDetailModal/TestDetailModal";

const WATER_UPPER_LIMIT = 0.5;
const WATER_LOWER_LIMIT = 0;

const mapStateToProps = (state) => {
  return {
    measurementType: getMeasurementType(state.measurements)("Water"),
  };
};

const sampledByRenderer = (rowData) => {
  const sampledBy = rowData.sample?.sampled_by ?? "-";
  return <div>{sampledBy}</div>;
};

const measurementRenderer = (measurementType) =>
  function measurementRendererInner(rowData, columnKey) {
    const defaultAlertSpec = {
      measurement_unit: measurementType.unit,
      upper_limit: WATER_UPPER_LIMIT,
      lower_limit: WATER_LOWER_LIMIT,
    };

    try {
      const value = getMeasurementValue(
        rowData.measurements[columnKey].value,
        measurementType.decimals
      );
      const unit = rowData.measurements[columnKey].unit;

      return (
        <MeasurementStatus
          value={value}
          unit={unit}
          labels={rowData.labels}
          status={rowData.status}
          defaultAlertSpec={defaultAlertSpec}
          alertSpec={getAlertSpec(
            rowData.measurement_alert_specs,
            measurementType.name,
            defaultAlertSpec
          )}
          measurementType={measurementType}
        />
      );
    } catch {
      return null;
    }
  };

const driftValueRenderer = (rowData, columnKey) => {
  return rowData.metadata?.[columnKey] ?? "-";
};

const sortBySampledBy = (list) =>
  [...list].sort((a, b) => {
    const aValue = a.sample?.sampled_by ?? "-";
    const bValue = b.sample?.sampled_by ?? "-";

    return aValue.localeCompare(bValue);
  });

const sortByDriftValue = (list) =>
  [...list].sort((a, b) => {
    const aValue = a?.metadata?.drift ?? 0;
    const bValue = b?.metadata?.drift ?? 0;

    return aValue - bValue;
  });

const headers = (measurementType) => {
  return [
    {
      label: "Name",
      key: "name",
      width: 400,
      fixed: true,
    },
    {
      label: "Sample State",
      key: "sample_state",
      width: 150,
      cellRenderer: (row) => sampleStateRenderer(row.sample),
      sort: sortBySampleState,
    },
    {
      label: "Date",
      key: "date",
      width: 170,
      cellRenderer: dateRenderer,
    },
    {
      label: "Tester",
      key: "tested_by",
      width: 150,
      suppress: true,
    },
    {
      label: "Sampled By",
      key: "sample.sampled_by",
      width: 150,
      cellRenderer: sampledByRenderer,
      sort: sortBySampledBy,
    },
    {
      label: measurementType.display_name,
      key: measurementType.name,
      width: 250,
      cellRenderer: measurementRenderer(measurementType),
      sort: sortByMeasurement,
    },
    {
      label: "Drift",
      key: "drift",
      width: 150,
      cellRenderer: driftValueRenderer,
      sort: sortByDriftValue,
    },
    {
      label: "Sample Start Date",
      key: "started_at",
      width: 170,
      cellRenderer: sampleDateRenderer,
      sort: sortBySampleDate,
    },
    {
      label: "Sample End Date",
      key: "ended_at",
      width: 170,
      cellRenderer: sampleDateRenderer,
      sort: sortBySampleDate,
    },
    notesColumn,
  ];
};

const IntrumentAquamaxTests = (props) => {
  return (
    <InstrumentDetail
      testId={props.match.params.testId}
      height={props.height}
      instrumentInfo={props.instrumentInfo}
      ReportModalComponent={TestDetailModal}
      filterKey="name"
      headers={headers(props.measurementType)}
      defaultSortBy="date"
      defaultSortDirection="desc"
    />
  );
};

IntrumentAquamaxTests.propTypes = {
  match: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  instrumentInfo: PropTypes.object.isRequired,
  measurementType: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, undefined)(IntrumentAquamaxTests);
